import { uid } from "uid";
import { getLang } from "../../js/utils/functions";
import { serializeContentItems } from "./utils";

export const constants = {
  CREATE_CONTENT_ITEM_STORE: "CREATE_CONTENT_ITEM_STORE",
  REMOVE_CONTENT_ITEM_STORE: "REMOVE_CONTENT_ITEM_STORE",
  CHANGE_CONTENT_ITEM_STORE: "CHANGE_CONTENT_ITEM_STORE",
  CHANGE_NAME: "CHANGE_NAME",
  SET_PROJECT_STORE: "SET_PROJECT_STORE",
  GET_PROJECT: "GET_PROJECT",
  GET_PROJECT_SUCCESS: "GET_PROJECT_SUCCESS",
  GET_PROJECT_ERROR: "GET_PROJECT_ERROR",
  SET_PROJECT: "SET_PROJECT",
  SET_PROJECT_SUCCESS: "SET_PROJECT_SUCCESS",
  SET_PROJECT_ERROR: "SET_PROJECT_ERROR",
  DELETE_PROJECT: "DELETE_PROJECT",
  DELETE_PROJECT_SUCCESS: "DELETE_PROJECT_SUCCESS",
  DELETE_PROJECT_ERROR: "DELETE_PROJECT_ERROR",
  GET_AREAS: "GET_AREAS",
  GET_AREAS_SUCCESS: "GET_AREAS_SUCCESS",
  GET_AREAS_ERROR: "GET_AREAS_ERROR",
  GET_SOFTWARES: "GET_SOFTWARES",
  GET_SOFTWARES_SUCCESS: "GET_SOFTWARES_SUCCESS",
  GET_SOFTWARES_ERROR: "GET_SOFTWARES_ERROR",
  UPDATE_CONTENT_ITEMS_POSITION_STORE: "UPDATE_CONTENT_ITEMS_POSITION_STORE",
  SET_RECAPTCHA_VERSION_STORE: "SET_RECAPTCHA_VERSION_STORE",
  GET_ASSOCIABLE_COURSES: "GET_ASSOCIABLE_COURSES",
  GET_ASSOCIABLE_COURSES_SUCCESS: "GET_ASSOCIABLE_COURSES_SUCCESS",
  GET_ASSOCIABLE_COURSES_ERROR: "GET_ASSOCIABLE_COURSES_ERROR",
  GET_COURSE: "GET_COURSE",
  GET_COURSE_SUCCESS: "GET_COURSE_SUCCESS",
  GET_COURSE_ERROR: "GET_COURSE_ERROR",
  SET_EMBED_START_LOADING: "SET_EMBED_START_LOADING",
  SET_EMBED_STOP_LOADING: "SET_EMBED_STOP_LOADING",
  SET_IMAGE_START_LOADING: "SET_IMAGE_START_LOADING",
  SET_IMAGE_STOP_LOADING: "SET_IMAGE_STOP_LOADING",
  SET_COVER_START_LOADING: "SET_COVER_START_LOADING",
  SET_COVER_STOP_LOADING: "SET_COVER_STOP_LOADING",
};
// TODO: Areas and software should be a generic/common "component" because can be called by diferents pages

const lang = getLang;
const projectSessionId = uid(32);

export const saveProjectQuery = (data, isPublic) => {
  const {
    id,
    name,
    contentItems,
    areaIds,
    softwareIds,
    madeAt,
    cover,
    coverFileName,
    courseId,
    url,
    client,
    clientUrl,
    agency,
    agencyUrl,
    sharedVisibility,
  } = data;
  const items = serializeContentItems(contentItems);

  let query = `mutation { saveProject(project: { name: "${name}", courseId: ${courseId}, contentItemsAttributes: [${items}], areaIds: [${areaIds}], softwareIds: [${softwareIds}], client: "${client}", clientUrl: "${clientUrl}", url: "${url}", agency: "${agency}", agencyUrl: "${agencyUrl}", public: ${isPublic}`;

  if (id) {
    query += `, id: ${id}`;
  }

  if (typeof sharedVisibility === "boolean") {
    query += `, sharedVisibility: ${sharedVisibility}`;
  }

  if (cover === "") {
    query += `, cover: ""`;
  } else if (cover) {
    query += `, cover: "${cover}"`;
  }

  if (madeAt) {
    query += `, madeAt: ${madeAt}`;
  }

  query += ` }) { project { id name contentItems { id itemType description descriptionHtml caption s3Image { url(sizes: [{ width: 30, height: 30 }, { width: 100, height: 200 }]) } s3ImageFileName url embedUrl embedHtml embedTitle embedType embedAuthorName embedProviderName embedThumbnailUrl humanizedItemType position errors { key messages } } course { id title areas { id name } } cover { url(sizes: { width:360, height: 360 }) } areas { id name } softwares { id name } madeAt client clientUrl agency agencyUrl url sharedVisibility railsRoutes { projectUrl } user { railsRoutes { portfolioUserUrl } } errors { key messages } } error { code description } } }`;

  return query;
};

export const services = {
  saveProject: (data, isPublic, reCaptchaToken) => ({
    headers: {
      "Accept-Language": lang,
      "Project-Session-ID": projectSessionId,
    },
    data: {
      query: saveProjectQuery(data, isPublic),
      "g-recaptcha-response-data": reCaptchaToken,
    },
  }),
  getProject: id => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: `{ projects(id: ${id}) { edges { node { id name contentItems { id itemType description descriptionHtml caption s3Image { url(sizes: [{ width: 30, height: 30 }, { width: 100, height: 200 }]) } s3ImageFileName url embedUrl embedHtml embedTitle embedAuthorName embedProviderName humanizedItemType position errors { key messages } } course { id title areas { id name } } cover { url(sizes: { width:360, height: 360 }) } areas { id name } softwares { id name } url madeAt client clientUrl agency agencyUrl sharedVisibility errors { key messages } user { railsRoutes { portfolioUserUrl } } } } } }`,
    },
  }),
  destroyProject: id => ({
    headers: {
      "Accept-Language": lang,
      "Project-Session-ID": projectSessionId,
    },
    data: {
      query: `mutation { destroyProject(project: {id: ${id}}) { project { id name user { railsRoutes { portfolioUserUrl } } errors { key messages } } errors } }`,
    },
  }),
  getAreas: () => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: "{ areas { edges { node { id name } } } }",
    },
  }),
  getSoftwares: () => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: "query { softwares { edges { node { id name } } } }",
    },
  }),
  getAssociableCourses: id => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: `{ associableCoursesToProject(projectId: ${id}) { edges { node { id title areas { id name } } } } }`,
    },
  }),
  getCourse: id => ({
    headers: {
      "Accept-Language": lang,
    },
    data: {
      query: `{ courses(id: ${id}) { edges { node { id title areas { id name } } } } }`,
    },
  }),
};
